import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'
import {
  dv360NegativeKeywordListsSelector,
  dv360NegativeKeywordListsWasLoadedSelector,
  getDv360NegativeKeywordListsIsLoadingSelector
} from '../../../../modules/selectors/dv360Constants'
import { getDv360NegativeKeywordLists } from '../../../../modules/actions/dv360Constants'

import { KEYWORD_EXCLUSION_LISTS } from '../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

import useStyles from '../CategoriesSection/styles'
import useDrawerFormStyles from '../../../../styles/common/drawerForms'

const KeywordExclusionListsSection = ({ formik }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { values, setFieldValue } = formik

  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const dv360NegativeKeywordLists = useSelector(dv360NegativeKeywordListsSelector)
  const getDv360NegativeKeywordListsIsLoading = useSelector(getDv360NegativeKeywordListsIsLoadingSelector)
  const dv360NegativeKeywordListsWasLoaded = useSelector(dv360NegativeKeywordListsWasLoadedSelector)

  const formattedKeywordExclusionLists = useMemo(() => {
    return dv360NegativeKeywordLists.map(item => ({
      label: item.name,
      value: item.id
    }))
  }, [dv360NegativeKeywordLists])

  useEffect(() => {
    if (!dv360NegativeKeywordListsWasLoaded) {
      dispatch(
        getDv360NegativeKeywordLists({
          account: selectedAdAccountId
        })
      )
    }
  }, [dispatch, selectedAdAccountId, dv360NegativeKeywordListsWasLoaded])

  return (
    <section className={classnames(drawerFormClasses.section, classes.categoriesSection)}>
      <h3 className={drawerFormClasses.sectionTitle}>{t('Exclusion keywords')}</h3>
      <MultiSelectBox
        placeholder={t('Add a keyword exclusion list')}
        options={formattedKeywordExclusionLists}
        name={KEYWORD_EXCLUSION_LISTS}
        value={values[KEYWORD_EXCLUSION_LISTS]}
        isLoading={getDv360NegativeKeywordListsIsLoading}
        setFieldValue={setFieldValue}
      />
    </section>
  )
}

export default KeywordExclusionListsSection
